
import { store } from '../../../../store';

export let ProPic = () => {
let {images, imagesPreview, website, activities, user} = store.getState()
    for(let i=0; i<imagesPreview.length; i++ )
     {    
        if(imagesPreview[i].alt_name==='propic')
          if(imagesPreview[i].img_url !== null && imagesPreview[i].img_url !== undefined)
            return imagesPreview[i].img_url
    }
    for(let i=0; i<images.length; i++ )
          {    
          if(images[i].alt_name==='propic')
            if(images[i].img_url !== null && images[i].img_url !== undefined)
            return `${process.env.REACT_APP_API}/${images[i].img_url}`
          }
  if(activities.edit || user.route === 'dashboard') {
    if(website.name) {
    let siteName = website.name
    return `https://dummyimage.com/500x500/00cc88/fff.jpg&text=${siteName[0]}`
    }
    if(website.url) {
    let siteUrl = website.url
    return `https://dummyimage.com/500x500/00cc88/fff.jpg&text=${siteUrl[0]}`
    }
    else if(website.sites)
    {
      return `https://dummyimage.com/500x500/00cc88/fff.jpg&text=${website.sites[0].name[0]}`
    }
    else
    {
      return `https://dummyimage.com/500x500/00cc88/fff.jpg&text=addimage`
    }
  }
  else {
    return null
  }
}

export let CoverImageURL = () => {
let { images, imagesPreview, user, activities } = store.getState()
    for(let i=0; i<imagesPreview.length; i++ )
     {    
        if(imagesPreview[i].alt_name==='cover')
          if(imagesPreview[i].img_url !== null && imagesPreview[i].img_url !== undefined)
            return imagesPreview[i].img_url
    }
    for(let i=0; i<images.length; i++ )
        {    
        if(images[i].alt_name==='cover')
          if(images[i].img_url !== null && images[i].img_url !== undefined)
          return `${process.env.REACT_APP_API}/${images[i].img_url}`
        }
if(activities.edit || user.route === 'dashboard') {
  return `${process.env.REACT_APP_API}/img/noimage.png`
}
else return null
}